<template>
  <div class="ds-textarea-container">
    <textarea class="textarea" :class="{'is-simplified': isSimplified, 'ds-input--has-limit-helper': (maxLength > 0)}" :value="modelValue" @input="input" @change="change"
              :placeholder="defaultText" @focus="$emit('focus')" @click="$emit('click')" ref="textarea" :maxlength="maxLength > 0 ? maxLength : null"></textarea>
    <div v-if="maxLength > 0" class="character-counter" :class="{'over-limit': currentLength >= maxLength}">
      {{ currentLength }}/{{ maxLength }}
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {
      autoresize: Boolean,
      lazy: Boolean,
      rows: null,
      modelValue: String,
      defaultText: String,
      disabled: {
        type: Boolean,
        default: false
      },
      isSimplified: {
        type: Boolean,
        default: false
      },
      maxLength: {
        type: Number,
        default: 0,
      }
    },
    emits: ['click', 'update:modelValue', 'focus', 'blur'],
    computed: {
      minHeight () {
        return 14 + (parseInt(this.rows, 10) || 1) * 21
      },
      currentLength () {
        return (this.modelValue || '').length
      }
    },
    methods: {
      focus () {
        this.$refs.textarea.focus()
      },
      input (evt) {
        this.lazy || this.$emit('update:modelValue', evt.target.value, evt)
        this.resize()
      },
      change (evt) {
        this.lazy && this.$emit('update:modelValue', evt.target.value, evt)
        this.resize()
      },
      resize (shrink) {
        if (this.autoresize && this.$el) {
          if (!shrink && this.$el.offsetHeight > this.$el.scrollHeight - 10) {
            return
          }
          this.$el.style.height = '6px'
          this.$el.style.height = Math.max(this.minHeight, this.$el.scrollHeight) + 2 + 'px'
          setTimeout(() => {
            if (this.$el) {
              this.$el.style.height = Math.max(this.minHeight, this.$el.scrollHeight) + 2 + 'px'
            }
          })
        }
      }
    },
    mounted () {
      this.resize(1)
    },
    watch: {
      modelValue () {
        setTimeout(() => {
          this.resize()
        })
      }
    }
  })
</script>
<style lang="scss" scoped>
  @import "../../../scss/variables.scss";

  .ds-textarea-container {
    position: relative;
  }

  .textarea {
    resize: none;
  }

  .ds-input--has-limit-helper {
    padding-bottom: 25px;
  }

  .character-counter {
    position: absolute;
    bottom: 8px;
    right: 8px;
    font-size: 11px;
    color: black;
    pointer-events: none;
    z-index: 1;
  }

  .character-counter.over-limit {
    color: red;
  }

</style>
